import { create } from 'zustand';

interface InspectionState {
  ticket: string | null;
  isSessionActive: boolean;
  note: string;
  inspectionTicket: any;
  boxIsConnected:
    | {
        connected_status_updated_at?: string;
        direct_mode_status_updated_at?: string;
        is_connected: boolean;
        is_direct_mode: boolean;
      }
    | undefined; // Optional property to track box connection status
  setTicket: (ticket: string | null) => void;
  setInspectionTicket: (inspectionTicket: any) => void;
  setNote: (note: string) => void;
  setSessionActive: (active: boolean) => void;
  setBoxIsConnected: (isConnected: boolean, isDirectMode: boolean) => void;
  reset: () => void;
}

export const useInspectionStore = create<InspectionState>((set) => ({
  ticket: null,
  note: '',
  isSessionActive: false,
  boxIsConnected: undefined,
  inspectionTicket: null,
  setTicket: (ticket) => set({ ticket }),
  setSessionActive: (active) => set({ isSessionActive: active }),
  setInspectionTicket: (inspectionTicket) => set({ inspectionTicket }),
  setBoxIsConnected: (isConnected: boolean, isdirectMode) =>
    set((state) => ({
      boxIsConnected: {
        ...state.boxIsConnected,
        is_connected: isConnected,
        is_direct_mode: isdirectMode,
      },
    })),
  setNote: (note) => set({ note }),
  reset: () =>
    set({
      ticket: null,
      isSessionActive: false,
      note: '',
      inspectionTicket: null,
      boxIsConnected: undefined, // Reset box connection status
    }),
}));
